<template>
  <div class="">
      <p>No dashboard available</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>